import React from 'react';
import { BackendError } from '../../fetchGraphQL';
import classNames from 'classnames';
import styles from './LocalErrorBoundary.module.scss';
import { ErrorIcon } from '../Icon/Icon';
import { useTranslation } from 'react-i18next';

const decorateWithHooks = (Component) => {
    return (props) => {
        const { t } = useTranslation();
        return <Component t={t} {...props} />;
    };
};

class BackendErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        if (error instanceof BackendError) {
            return { hasError: true, error: error };
        }
        throw error;
    }

    componentDidCatch(error, info) {
        console.log('Backend error:', error.message);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    className={classNames({
                        [styles.LocalErrorBoundary]: true,
                        [styles.LocalErrorBoundaryMultiline]: true,
                    })}
                >
                    <ErrorIcon className={styles.ErrorIcon} />
                    <span className={styles.ErrorMessage}>
                        {this.state.error instanceof BackendError
                            ? this.state.error.message
                            : this.props.t('generics.unexpectedError')}
                    </span>
                </div>
            );
        }
        return this.props.children;
    }
}

export default decorateWithHooks(BackendErrorBoundary);
